/*
  *******************
      注册全局组件
  *******************
*/
import Vue from 'vue'
import layout from '~/components/layout'
import layoutSidebar from '~/components/layout/sidebar'
import layoutContainer from '~/components/layout/container'
import layoutContainerMain from '~/components/layout/container/main'
import layoutContainerHeader from '~/components/layout/container/header'
import layoutContainerMainContent from '~/components/layout/container/main/main-content.vue'
import layoutOuter from '~/components/layout/outer'

import textLabelValue from '~/components/text/text-label-value.vue'
import xText from '~/components/x-text/index'
import xTextItem from '~/components/x-text/x-text-item'

// 布局组件
Vue.component('layout', layout)
Vue.component('layoutSidebar', layoutSidebar)
Vue.component('layoutContainer', layoutContainer)
Vue.component('layoutContainerHeader', layoutContainerHeader)
Vue.component('layoutContainerMain', layoutContainerMain)
Vue.component('layoutContainerMainContent', layoutContainerMainContent)
Vue.component('layoutOuter', layoutOuter)

Vue.component('textLabelValue', textLabelValue)
Vue.component('xText', xText)
Vue.component('xTextItem', xTextItem)



// WEBPACK FOOTER //
// ./src/utils/components.js